<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Pest/Disease Sighting', apiMethod: 'AfflictionSightings', form: () => import('../forms/AfflictionSightingForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                ],
                mainForm: () => import('../forms/AfflictionSightingForm'),
                claimName: 'AfflictionSightings',
                apiMethod: 'AfflictionSightings',
            }
        }
    };
</script>
